import { SERVICE_ROUTES } from "../constants/serviceRoutes";

export const searchIndex = [
  {
    title: 'Research & Development',
    keywords: ['research', 'development', 'r&d', 'innovation'],
    path: '/research-and-development'
  },
  {
    title: 'Object Detection & Tracking',
    keywords: ['object detection', 'tracking', 'computer vision', 'ai'],
    path: '/object-detection'
  },
  {
    title: 'Autonomous Navigation',
    keywords: ['autonomous', 'navigation', 'robotics', 'self driving'],
    path: '/autonomous-navigation'
  },
  {
    title: 'Edge Computing',
    keywords: ['edge', 'edge computing', 'iot edge'],
    path: '/edge-computing'
  },
  {
    title: 'IoT Integration',
    keywords: ['iot', 'integration', 'sensors', 'devices'],
    path: '/iot-integration'
  },
  {
    title: 'Contact Us',
    keywords: ['contact', 'us', 'get in touch', 'support'],
    path: '/contact-us'
  },
  {
    title: 'About Us',
    keywords: ['about', 'company', 'team', 'mission'],
    path: '/about-us'
  },
  {
    title: 'Career',
    keywords: ['career', 'jobs', 'employment', 'opportunities'],
    path: '/careers'
  },
  {
    title: 'Newsroom',
    keywords: ['news', 'press', 'updates', 'media'],
    path: '/newsroom'
  },
  {
    title: 'Fraud Alert',
    keywords: ['fraud alert', 'recruitment fraud', 'job scam', 'fake offers', 'career fraud'],
    path: '/fraud-alert'
  },
  {
    title: 'Payroll Services',
    keywords: ['payroll', 'salary', 'wages'],
    path: SERVICE_ROUTES.payrollServices
  },
  {
    title: 'Payroll Software',
    keywords: ['payroll', 'software', 'hr', 'salary'],
    path: SERVICE_ROUTES.payrollSoftware
  },
  {
    title: 'HR Insights',
    keywords: ['hr insights', 'employee insights'],
    path: SERVICE_ROUTES.hrInsights
  },
  {
    title: 'HR Services',
    keywords: ['hr', 'human resources', 'employee management', 'payroll'],
    path: SERVICE_ROUTES.hrServices
  },
  {
    title: 'Partner Integration',
    keywords: ['partner', 'integration', 'api', 'third party'],
    path: SERVICE_ROUTES.partnerIntegration
  },
  {
    title: 'Health Services',
    keywords: ['health services', 'healthcare', 'medical coding', 'medical billing', 'rcm', 'claims'],
    path: SERVICE_ROUTES.healthIndex
  },
  {
    title: 'Medical Coding',
    keywords: ['medical coding', 'health services', 'icd-10', 'cpt', 'hcpcs', 'coding audit'],
    path: SERVICE_ROUTES.medicalCoding
  },
  {
    title: 'Medical Billing',
    keywords: ['medical billing', 'health services', 'claims', 'revenue cycle', 'denial management'],
    path: SERVICE_ROUTES.medicalBilling
  },
  {
    title: 'Revenue Cycle Management (RCM)',
    keywords: ['revenue cycle management', 'rcm', 'health services', 'claims', 'payment posting', 'denial management'],
    path: SERVICE_ROUTES.revenueCycleManagement
  },
  {
    title: 'Claims Management',
    keywords: ['claims management', 'health services', 'claim tracking', 'payer follow-up', 'rejections', 'denial appeals'],
    path: SERVICE_ROUTES.claimsManagement
  },
  {
    title: 'Insurance Eligibility Verification',
    keywords: ['insurance eligibility verification', 'health services', 'coverage verification', 'patient benefits', 'copay', 'deductible', 'prior authorization'],
    path: SERVICE_ROUTES.insuranceEligibilityVerification
  },
  {
    title: 'Blog',
    keywords: ['blog', 'news', 'updates', 'articles'],
    path: '/blog'
  },
  {
    title: 'Help Center',
    keywords: ['help', 'support', 'faq', 'troubleshooting'],
    path: '/help'
  },
  {
    title: 'API Docs',
    keywords: ['api', 'documentation', 'developer', 'integration'],
    path: '/apidocs'
  },
  {
    title: 'Privacy Policy',
    keywords: ['privacy', 'policy', 'data protection', 'terms'],
    path: '/privacy'
  },
  {
    title: 'Terms of Service',
    keywords: ['terms', 'service', 'legal', 'agreement'],
    path: '/terms'
  },
  {
    title: 'Security',
    keywords: ['security', 'cybersecurity', 'data protection', 'safety'],
    path: '/security'
  },
  {
    title: 'Data Science with AI',
    keywords: ['data science', 'ai', 'machine learning', 'analytics'],
    path: SERVICE_ROUTES.dataScienceAi
  },
  {
    title: 'Object Detection',
    keywords: ['object detection', 'tracking'],
    path: SERVICE_ROUTES.objectDetection
  },
  {
    title: 'Cloud Security',
    keywords: ['cloud', 'security', 'data protection', 'safety'],
    path: SERVICE_ROUTES.cloudSecurity
  },
  {
    title: 'UI/UX Design',
    keywords: ['ui', 'ux', 'design'],
    path: SERVICE_ROUTES.uiUxDesign
  },
  {
    title: 'Mobile Development',
    keywords: ['mobile', 'development', 'apps', 'ios', 'android'],
    path: SERVICE_ROUTES.mobileDevelopment
  },
  {
    title: 'AI & ML',
    keywords: [ 'ai', 'machine learning', 'analytics'],
    path: SERVICE_ROUTES.aiMlServices
  },
  {
    title: 'Data Science',
    keywords: ['data science'],
    path: SERVICE_ROUTES.dataScience
  },
  {
    title: 'Our Services',
    keywords: ['our services', 'services', ' offerings'],
    path: SERVICE_ROUTES.index
  },
  {
    title: 'Bpo Services',
    keywords: ['bpo', 'business process outsourcing', 'customer service', 'data entry'],
    path: SERVICE_ROUTES.bpoServices
  },
  {
    title: 'Content Moderation',
    keywords: ['content', 'moderation', 'community guidelines', 'spam detection'],
    path: SERVICE_ROUTES.contentModeration
  },
  {
    title: 'customer support',
    keywords: ['customer', 'support', 'help', 'service'],
    path: SERVICE_ROUTES.customerSupport
  },
  {
    title: 'HR & Payroll Operations',
    keywords: ['hr', 'payroll', 'employee management', 'salary'],
    path: SERVICE_ROUTES.hrPayrollOperations
  },
  {
    title: 'recruitment process outsourcing',
    keywords: ['recruitment', 'process', 'outsourcing', 'hr'],
    path: SERVICE_ROUTES.recruitmentProcessOutsourcing
  },
  {
    title: 'Back Office Operations',
    keywords: ['back office', 'operations', 'administrative', 'support'],
    path: SERVICE_ROUTES.backOfficeOperations
  },
  {
    title: 'Data entry services',
    keywords: ['data entry', 'data input', 'admin support'],
    path: SERVICE_ROUTES.dataEntryServices
  },
  {
    title: 'Technical Support',
    keywords: ['technical', 'support', 'help', 'service'],
    path: SERVICE_ROUTES.technicalSupport
  }

];
